'use strict';

/* eslint no-undef: "off" */
/**
 * get product Info images api
 */
define('productInfoImgApi',['baseApiGet'], function (baseApiGet) {
  return function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return baseApiGet('/rest/V1/xmapi/productimages', params);
  };
});
